import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { map, uniqueId } from 'lodash';
import { FormattedMessage } from 'react-intl';

const ButtonGroup = styled.div`
  display: flex;
`;

const Buttons = styled.div``;

const Button = styled.input`
  width: 15px;
  height: 15px;
`;

const Label = styled.label`
  display: flex;
  justify-content: center;
  font-size: ${props => props.labelSize || '15px'};
  font-weight: ${props => props.boldLabel && 'bold'};
  line-height: 16px;
`;

const Text = styled.span`
  padding-top: 3px;
  padding-left: 3px;
  padding: ${props => props.textPadding};
  opacity: ${props => props.disabled && '0.5'};
  align-self: center;
`;

const Checkbox = ({
  data,
  name,
  onChange,
  checked,
  labelSize,
  boldLabel,
  textPadding,
  disabled,
  ...props
}) => (
  <ButtonGroup {...props}>
    {map(data, (button, index) => (
      <Buttons key={`${uniqueId('checkBox')}.${index}`}>
        <Label
          boldLabel={boldLabel}
          labelSize={labelSize}
          htmlFor={`${uniqueId('button_')}.${button.value}`}
        >
          <Button
            onChange={!disabled ? onChange : () => null}
            id={`${uniqueId('button_')}.${button.value}`}
            name={name}
            type="checkbox"
            checked={checked}
            value={button.value}
            disabled={disabled}
          />
          <Text textPadding={textPadding} disabled={disabled}>
            <FormattedMessage id={button.text} />
          </Text>
        </Label>
      </Buttons>
    ))}
  </ButtonGroup>
);

Checkbox.defaultProps = {
  textPadding: null,
  labelSize: null,
  boldLabel: false,
  disabled: false,
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  checked: PropTypes.bool.isRequired,
  textPadding: PropTypes.string,
  labelSize: PropTypes.string,
  boldLabel: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Checkbox;
